import { CAR_SCREEN_HEIGHT, CAR_SCREEN_WIDTH } from "./CarScreenViewport";
import { DraggablePopup } from "../design-system/DraggablePopup";
import { assetUrl } from "../../utils/assetUrl";
import "./NightCards.css";
import "./ParcelShowcaseDetail.css";

const PARCEL_DETAIL_IMAGE_SRC = assetUrl("assets/figma/night-ai/parcel-detail-screenshot.webp");
const POPUP_WIDTH = 650;
const POPUP_HEIGHT = 1336;
const POPUP_MARGIN = 24;
const INITIAL_POSITION = {
  x: 1432,
  y: 132
};
const POPUP_SIZE = { width: POPUP_WIDTH, height: POPUP_HEIGHT };
const POPUP_BOUNDS = { width: CAR_SCREEN_WIDTH, height: CAR_SCREEN_HEIGHT };

export function ParcelDetailPopup({
  onClose,
  demoPickup
}: {
  onClose: () => void;
  demoPickup?: { pointName: string; pendingCount: number; inTransitCount?: number };
}) {
  const pendingCount = Math.max(0, Math.floor(demoPickup?.pendingCount ?? 0));
  const inTransitCount = demoPickup?.inTransitCount ?? 0;

  return (
    <DraggablePopup
      ariaLabel="快递详情页"
      bounds={POPUP_BOUNDS}
      className={`parcel-detail-popup${demoPickup ? " parcel-showcase-detail" : ""}`}
      draggingClassName="parcel-detail-popup--dragging"
      initialPosition={INITIAL_POSITION}
      margin={POPUP_MARGIN}
      size={POPUP_SIZE}
    >
      {demoPickup ? (
        <div className="parcel-showcase-detail__content">
          <header className="parcel-showcase-detail__header">
            <span>我的快递</span>
            <small>演示数据</small>
          </header>
          <div className="parcel-showcase-detail__summary">
            <span className="parcel-showcase-detail__eyebrow">待领取</span>
            <h2>{pendingCount}<span>件快递</span></h2>
            <p>{pendingCount ? demoPickup.pointName : inTransitCount ? `${inTransitCount} 件正在运输中` : "暂无待取或运输中的快递"}</p>
          </div>
          <div className="parcel-showcase-detail__parcels" aria-label="待取快递列表">
            {inTransitCount > 0 ? <article className="parcel-showcase-detail__parcel"><div className="parcel-showcase-detail__parcel-heading"><h3>包裹 01</h3><span>运输中</span></div><p>包裹正在送往收件城市</p><small>演示物流状态 · 尚未到达取件点</small></article> : null}
            {Array.from({ length: pendingCount }, (_, index) => (
              <article className="parcel-showcase-detail__parcel" key={index}>
                <div className="parcel-showcase-detail__parcel-heading">
                  <h3>包裹 {String(index + 1).padStart(2, "0")}</h3>
                  <span>待取件</span>
                </div>
                <p>演示取件码</p>
                <strong>{index === 0 ? "A-0128" : index === 1 ? "B-0639" : `C-${String(index + 1).padStart(4, "0")}`}</strong>
                <small>请前往驿站领取</small>
              </article>
            ))}
          </div>
          <footer className="parcel-showcase-detail__notice">
            <strong>{pendingCount ? "到达不代表已领取" : inTransitCount ? "还在路上" : "当前没有待取包裹"}</strong>
            <p>{pendingCount ? "快递仍在驿站，取件状态保持待领取。" : inTransitCount ? "包裹尚未到站，无需前往取件。" : "查询结果为本次演示状态。"}</p>
          </footer>
        </div>
      ) : (
        <img className="parcel-detail-popup__image" src={PARCEL_DETAIL_IMAGE_SRC} alt="我的快递详情页" draggable={false} />
      )}
      <button
        type="button"
        className="parcel-detail-popup__close"
        aria-label="关闭快递详情页"
        onPointerDown={(event) => event.stopPropagation()}
        onClick={onClose}
      >{demoPickup ? "×" : null}</button>
    </DraggablePopup>
  );
}
